import formsSelect from "./single-antenne/components/forms.js";
import initMap from "./single-antenne/components/initMap";
import TestimoniesSlider from "./single-antenne/components/testimonies-slider.js";

formsSelect();

document.addEventListener("DOMContentLoaded", function () {
    window.initMap = initMap;

    // Testimonies slider component
    const testimoniesSliderElements = document.querySelectorAll(".testimonies-list");
    if (testimoniesSliderElements.length) {
        testimoniesSliderElements.forEach((el) => {
            const testimoniesSlider = new TestimoniesSlider(el);
        });
    }

});
